import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { cybervolunteerApi } from "./api/cybervolunteerApi";
import { clearStorage } from "./lib";
import AboutPage from "./pages/AboutPage";
import AdminEditTaskPage from "./pages/AdminEditTaskPage/AdminEditTaskPage.tsx";
import AdminPage from "./pages/AdminPage/AdminPage.tsx";
import AdminTaskListPage from "./pages/AdminTaskListPage/AdminTaskListPage.tsx";
import ContactsPage from "./pages/ContactsPage";
import CreateTaskPage from "./pages/CreateTaskPage/CreateTaskPage.tsx";
import LessonPage from "./pages/LessonPage";
import LoginPage from "./pages/LoginPage";
import MainPage from "./pages/MainPage";
import NewUserPage from "./pages/NewUserPage";
import PersonalPage from "./pages/PersonalPage/PersonalPage.tsx";
import PrivacyPage from "./pages/PrivacyPage";
import { SiteDataProvider } from "./SiteDataContext";

function App() {
  const [siteData, setSiteData] = useState({});

  const getSiteTexts = () => {
    cybervolunteerApi
      .getSiteTexts()
      .then((response) => {
        setSiteData((prevState) => ({ ...prevState, texts: response.data }));
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  };

  const updateLessons = () => {
    cybervolunteerApi
      .getLessons()
      .then((response) => {
        setSiteData((prevState) => ({ ...prevState, lessons: response.data }));
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        if (error.response?.status === 401) {
          clearStorage();
          window.location.reload();
        }
      });
  };

  const getLessons = () => {
    cybervolunteerApi
      .getAnonymousLessons()
      .then((response) => {
        const lessons = response.data;
        lessons.map((item) => {
          item.anonymous = true;
          return item;
        });

        setSiteData((prevState) => ({ ...prevState, lessons: lessons }));
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        if (error.response?.status === 401) {
        }
      });
  };

  useEffect(() => {
    const authToken = localStorage.getItem("auth_token");
    if (!authToken) {
      getLessons();
      return;
    }
  }, []);

  useEffect(() => {
    getSiteTexts();
  }, []);

  useEffect(() => {
    const authToken = localStorage.getItem("auth_token");
    if (!authToken) {
      clearStorage();
      return;
    }

    if (!siteData.lessons?.length) {
      updateLessons();
    }
  }, [siteData.username, siteData.lessons?.length]);

  return (
    <SiteDataProvider siteData={siteData} setSiteData={setSiteData}>
      <Router>
        {/* <MobileMenu /> */}
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/new-user" element={<NewUserPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/lesson/:lessonId" element={<LessonPage />} />
          <Route path="/lk" element={<PersonalPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/create_task" element={<CreateTaskPage />} />
          <Route path="/edit_task/:subtaskId" element={<AdminEditTaskPage />} />
          <Route path="/task_list_admin" element={<AdminTaskListPage />} />
          <Route path="/page_admin" element={<AdminPage />} />
        </Routes>
      </Router>
    </SiteDataProvider>
  );
}

export default App;
